import { render, staticRenderFns } from "./hediyeug.vue?vue&type=template&id=6dae96d8&scoped=true"
import script from "./hediyeug.vue?vue&type=script&lang=js"
export * from "./hediyeug.vue?vue&type=script&lang=js"
import style0 from "./hediyeug.vue?vue&type=style&index=0&id=6dae96d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae96d8",
  null
  
)

export default component.exports